import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CaseService } from 'src/app/services/case.service';
import { ContentService } from 'src/app/services/content.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CaseDocumentModel } from 'src/app/models/case-document.model';
import { IContentComponent } from 'src/app/interfaces/content-component.interface';

@Component({
  selector: 'app-feedback-form',
  templateUrl: './feedback-form.component.html',
  styleUrls: ['./feedback-form.component.scss']
})
export class FeedbackFormComponent implements OnInit, OnDestroy, IContentComponent {

  private componentDestroyed = new Subject();

  pageComponentName: string = 'Feedback';
  data!: Map<string, string>;

  message = '';
  selected: number = 0;
  hover: number = 0;

  caseUId!: string;
  currentCaseAttachment!: CaseDocumentModel;

  get loggedIn(): boolean {
    return this.authenticationService.isLoggedIn;
  }

  constructor(private route: ActivatedRoute, private router: Router, private authenticationService: AuthenticationService, private caseService: CaseService, private contentService: ContentService, private spinnerService: SpinnerService) {

    this.route.queryParams
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((params: Params) => {
        if (params.c) {
          this.caseUId = params.c;
        }
      });

      this.contentService.content
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (data: Map<string, string>) => {
          if (data !== undefined) {
            this.data = data;
          }
        }
      );

    this.contentService.loadContent('pageText', this.pageComponentName, ['text', 'label']);
  }

  getLabelValue(label:string): string {
    let value: string = '';
    if (this.data) {
      value = this.data.get(label) ?? '';
    }
    return value;
  }

  ngOnInit() {

  }

  ngAfterViewChecked() {
    this.scrollToTop()
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }

  scrollToTop() {
    (function smoothscroll() {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - (currentScroll / 5));
      }
    })();
  }

  toggle(val: number) {
    this.selected = val;
  }

  toggleHover(val: number) {
    if (this.hover === val) {
      this.hover = 0;
    } else {
      this.hover = val;
    }
  }

  getFontSet(value: number): string {
    if (this.selected === value || this.hover === value) {
      return 'material-icons-filled';
    }
    return 'material-icons-outlined';
  }
  submit(): void {

    if (this.selected !== 0) {

      const postData = {
        Comment: this.message,
        Score: this.selected
      };

      this.spinnerService.show('Sender tilbakemelding');
      this.caseService.saveFeedback(postData)
        .subscribe(
          (data: any) => {
            this.spinnerService.hide();
            this.closeForm();
          },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.spinnerService.hide();
          },
          () => {
            console.log('Finish submitting feedback');
          }
        );
    } else {
      this.closeForm();
    }
  }

  closeForm(): void {
    if (this.loggedIn) {
      this.router.navigate(['/cases/', this.caseUId]);
    } else {
      this.caseService.closeApplication();
    }
  }
}
